/* 
 * CART MONITOR v9 - SIMPLIFIED
 * - Shotglass removed when NO products
 * - Scoop removed when NO bi-monthly subscriptions
 * - No special bundle logic needed!
 */

(function() {
  console.log('👀 Cart monitor v9 initialized (Simplified)');

  // ⚙️ CONFIGURATIE
  const SHOTGLASS_PRODUCT_ID = '9874924634454';
  const SCOOP_PRODUCT_ID = '9888265601366';
  
  const SHOTGLASS_VARIANT_ID = '51556485562710';
  const SHOTGLASS_VARIANT_ID_OLD = '51556467212630';
  const SCOOP_VARIANT_ID = '51557504811350';
  
  function getBiMonthlyVariants() {
    if (window.biMonthlyVariants && window.biMonthlyVariants.length > 0) {
      return window.biMonthlyVariants;
    }
    
    try {
      const saved = sessionStorage.getItem('bioshots_bimonthly_variants');
      if (saved) {
        const variants = JSON.parse(saved);
        window.biMonthlyVariants = variants;
        console.log('📦 Loaded bi-monthly variants from session:', variants);
        return variants;
      }
    } catch (e) {
      console.warn('Could not load from sessionStorage:', e);
    }
    
    return [];
  }

  let isRemoving = false;
  let isInitialized = false;
  let userIsDeleting = false;

  // ============================================================
  // NOTIFICATION SYSTEM
  // ============================================================
  
  function showNotification(message, type = 'info') {
    const oldNotifications = document.querySelectorAll('.bioshots-cart-notification');
    oldNotifications.forEach(n => n.remove());

    const notification = document.createElement('div');
    notification.className = `bioshots-cart-notification bioshots-cart-notification--${type}`;
    notification.innerHTML = `
      <div class="bioshots-cart-notification__inner">
        <span class="bioshots-cart-notification__icon">
          ${type === 'info' ? 'ℹ️' : type === 'success' ? '✅' : '🎁'}
        </span>
        <span class="bioshots-cart-notification__text">${message}</span>
        <button class="bioshots-cart-notification__close" aria-label="Sluiten">×</button>
      </div>
    `;

    if (!document.querySelector('#bioshots-notification-styles')) {
      const style = document.createElement('style');
      style.id = 'bioshots-notification-styles';
      style.textContent = `
        .bioshots-cart-notification {
          position: fixed;
          top: 20px;
          right: 20px;
          z-index: 10000;
          max-width: 400px;
          background: white;
          border-radius: 8px;
          box-shadow: 0 4px 20px rgba(0,0,0,0.15);
          padding: 16px 20px;
          animation: slideInRight 0.3s ease;
          border-left: 4px solid #0f8a00;
        }
        .bioshots-cart-notification--info { border-left-color: #3b82f6; }
        .bioshots-cart-notification--gift { border-left-color: #0f8a00; }
        .bioshots-cart-notification__inner {
          display: flex;
          align-items: center;
          gap: 12px;
        }
        .bioshots-cart-notification__icon {
          font-size: 24px;
          line-height: 1;
          flex-shrink: 0;
        }
        .bioshots-cart-notification__text {
          flex: 1;
          font-size: 14px;
          line-height: 1.4;
          color: #333;
        }
        .bioshots-cart-notification__close {
          background: none;
          border: none;
          font-size: 24px;
          line-height: 1;
          cursor: pointer;
          color: #999;
          padding: 0;
          width: 24px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 4px;
          transition: all 0.2s;
        }
        .bioshots-cart-notification__close:hover {
          background: #f5f5f5;
          color: #333;
        }
        @keyframes slideInRight {
          from { transform: translateX(400px); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
        @keyframes slideOutRight {
          from { transform: translateX(0); opacity: 1; }
          to { transform: translateX(400px); opacity: 0; }
        }
        .bioshots-cart-notification.is-closing {
          animation: slideOutRight 0.3s ease forwards;
        }
        @media (max-width: 768px) {
          .bioshots-cart-notification {
            top: 10px;
            right: 10px;
            left: 10px;
            max-width: none;
          }
        }
      `;
      document.head.appendChild(style);
    }

    document.body.appendChild(notification);

    const closeBtn = notification.querySelector('.bioshots-cart-notification__close');
    closeBtn.addEventListener('click', () => {
      notification.classList.add('is-closing');
      setTimeout(() => notification.remove(), 300);
    });

    setTimeout(() => {
      if (notification && notification.parentNode) {
        notification.classList.add('is-closing');
        setTimeout(() => notification.remove(), 300);
      }
    }, 5000);

    console.log('📢 Notification shown:', message);
  }

  // ============================================================
  // GIFT BADGE SYSTEM
  // ============================================================

  function addGiftBadges() {
    const cartItems = document.querySelectorAll('.m-cart-item');

    cartItems.forEach(item => {
      const productId = item.getAttribute('data-product-id');
      const isGift = productId === SHOTGLASS_PRODUCT_ID || productId === SCOOP_PRODUCT_ID;

      if (isGift && !item.querySelector('.bioshots-gift-badge')) {
        console.log('🎁 Adding gift badge to item:', productId);

        const giftType = productId === SHOTGLASS_PRODUCT_ID ? 'shotglass' : 'scoop';
        const giftLabel = giftType === 'shotglass' 
          ? 'Gratis cadeau' 
          : 'Extra gratis bij 2-maands abonnement';

        const badge = document.createElement('div');
        badge.className = 'bioshots-gift-badge';
        badge.innerHTML = `
          <span class="bioshots-gift-badge__icon">🎁</span>
          <span class="bioshots-gift-badge__text">${giftLabel}</span>
        `;

        if (!document.querySelector('#bioshots-gift-badge-styles')) {
          const style = document.createElement('style');
          style.id = 'bioshots-gift-badge-styles';
          style.textContent = `
            .bioshots-gift-badge {
              display: inline-flex;
              align-items: center;
              gap: 6px;
              background: linear-gradient(135deg, #0f8a00 0%, #0ca500 100%);
              color: white;
              padding: 4px 10px;
              border-radius: 999px;
              font-size: 12px;
              font-weight: 600;
              margin-top: 8px;
              box-shadow: 0 2px 8px rgba(15, 138, 0, 0.2);
              animation: badgePulse 2s ease infinite;
            }
            .bioshots-gift-badge__icon {
              font-size: 14px;
              line-height: 1;
              animation: badgeIconBounce 2s ease infinite;
            }
            .bioshots-gift-badge__text {
              line-height: 1.2;
            }
            @keyframes badgePulse {
              0%, 100% { box-shadow: 0 2px 8px rgba(15, 138, 0, 0.2); }
              50% { box-shadow: 0 2px 12px rgba(15, 138, 0, 0.4); }
            }
            @keyframes badgeIconBounce {
              0%, 100% { transform: scale(1); }
              50% { transform: scale(1.1); }
            }
            .m-cart-item .bioshots-gift-badge {
              margin-top: 8px;
              margin-bottom: 4px;
            }
            @media (max-width: 768px) {
              .bioshots-gift-badge {
                font-size: 11px;
                padding: 3px 8px;
              }
              .bioshots-gift-badge__icon {
                font-size: 13px;
              }
            }
          `;
          document.head.appendChild(style);
        }

        const productTitle = item.querySelector('.m-cart-item__title');
        
        if (productTitle && productTitle.parentNode) {
          productTitle.parentNode.insertBefore(badge, productTitle.nextSibling);
        } else {
          item.insertBefore(badge, item.firstChild);
        }

        console.log('   ✅ Gift badge added');
      }
    });
  }

  // ============================================================
  // LOCK GIFT QUANTITIES
  // ============================================================

  function lockGiftQuantities() {
    console.log('🔒 Locking gift quantities...');
    
    const cartItems = document.querySelectorAll('.m-cart-item');

    cartItems.forEach(item => {
      const productId = item.getAttribute('data-product-id');
      const isGift = productId === SHOTGLASS_PRODUCT_ID || productId === SCOOP_PRODUCT_ID;

      if (isGift) {
        console.log('🔒 Locking gift item:', productId);

        const quantityInput = item.querySelector('.m-quantity__input');
        
        if (quantityInput) {
          quantityInput.value = 1;
          quantityInput.disabled = true;
          quantityInput.readOnly = true;
          quantityInput.style.cssText = 'opacity: 0.5 !important; cursor: not-allowed !important; pointer-events: none !important; background-color: #f5f5f5 !important;';
          
          quantityInput.addEventListener('change', function(e) {
            e.preventDefault();
            e.stopPropagation();
            this.value = 1;
            showNotification('Dit gratis cadeau kan niet worden aangepast in aantal.', 'info');
            return false;
          }, true);

          quantityInput.addEventListener('input', function(e) {
            e.preventDefault();
            e.stopPropagation();
            this.value = 1;
            return false;
          }, true);
          
          console.log('  ✅ Locked quantity input');
        }

        const quantityButtons = item.querySelectorAll('.m-quantity__button');
        quantityButtons.forEach((btn) => {
          btn.style.display = 'none !important';
          btn.disabled = true;
          btn.style.visibility = 'hidden';
          btn.style.pointerEvents = 'none';
          
          btn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            showNotification('Dit gratis cadeau kan niet worden aangepast in aantal.', 'info');
            return false;
          }, true);
        });

        const quantityWrapper = item.querySelector('.m-cart__column--quantity, m-quantity-input');
        
        if (quantityWrapper && !quantityWrapper.querySelector('.bioshots-locked-notice')) {
          const lockedNotice = document.createElement('div');
          lockedNotice.className = 'bioshots-locked-notice';
          lockedNotice.innerHTML = '🔒 Aantal: 1 (gratis cadeau)';
          lockedNotice.style.cssText = `
            font-size: 12px !important;
            color: #0f8a00 !important;
            font-weight: 600 !important;
            margin-top: 8px !important;
            display: block !important;
            text-align: center !important;
          `;
          quantityWrapper.appendChild(lockedNotice);
        }

        if (!document.querySelector('#bioshots-hide-gift-buttons')) {
          const style = document.createElement('style');
          style.id = 'bioshots-hide-gift-buttons';
          style.textContent = `
            [data-product-id="${SHOTGLASS_PRODUCT_ID}"] .m-quantity__button,
            [data-product-id="${SCOOP_PRODUCT_ID}"] .m-quantity__button {
              display: none !important;
              visibility: hidden !important;
              pointer-events: none !important;
            }
            [data-product-id="${SHOTGLASS_PRODUCT_ID}"] .m-quantity__input,
            [data-product-id="${SCOOP_PRODUCT_ID}"] .m-quantity__input {
              opacity: 0.5 !important;
              cursor: not-allowed !important;
              pointer-events: none !important;
              background-color: #f5f5f5 !important;
            }
          `;
          document.head.appendChild(style);
        }
      }
    });

    interceptCartUpdates();
  }

  function interceptCartUpdates() {
    if (window.bioshotsCartInterceptor) return;
    window.bioshotsCartInterceptor = true;

    const originalFetch = window.fetch;
    window.fetch = function(...args) {
      const [url, options] = args;
      
      if (url && url.includes('/cart/change.js') && options && options.body) {
        try {
          const body = JSON.parse(options.body);
          const itemKey = String(body.id);
          
          fetch('/cart.js')
            .then(r => r.json())
            .then(cart => {
              const item = cart.items.find(i => i.key === itemKey);
              if (item) {
                const isGift = String(item.variant_id) === SHOTGLASS_VARIANT_ID || 
                              String(item.variant_id) === SHOTGLASS_VARIANT_ID_OLD ||
                              String(item.variant_id) === SCOOP_VARIANT_ID;
                
                if (isGift && body.quantity && body.quantity > 1) {
                  console.log('🚫 Blocked attempt to increase gift quantity');
                  showNotification('Dit gratis cadeau kan niet worden aangepast in aantal.', 'info');
                  fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: itemKey, quantity: 1 })
                  });
                }
              }
            });
        } catch (e) {}
      }
      
      return originalFetch.apply(this, args);
    };
  }

  // ============================================================
  // CART FUNCTIONS
  // ============================================================

  async function getCart() {
    try {
      const response = await fetch('/cart.js');
      return await response.json();
    } catch (error) {
      if (error.message !== 'Failed to fetch') {
        console.error('Failed to fetch cart:', error);
      }
      return null;
    }
  }

  async function removeItemFromCart(variantId, itemName) {
    if (userIsDeleting) {
      console.log('⏸️ User is deleting - skipping auto-removal');
      return false;
    }

    if (isRemoving) {
      console.log('⏳ Already removing, skipping...');
      return false;
    }
    isRemoving = true;

    console.log(`🗑️ Removing ${itemName} (${variantId}) from cart...`);

    try {
      const cart = await getCart();
      if (!cart) {
        console.log('  ⚠️ Cart not found');
        isRemoving = false;
        return false;
      }

      const item = cart.items.find(item => 
        String(item.variant_id) === String(variantId)
      );

      if (!item) {
        console.log(`  ℹ️ ${itemName} not in cart (already removed)`);
        isRemoving = false;
        return false;
      }

      console.log(`  🎯 Found item to remove:`, item.title, 'key:', item.key);

      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: item.key,
          quantity: 0
        })
      });

      if (response.ok) {
        console.log(`  ✅ ${itemName} removed successfully`);
        
        let productIdToRemove;
        if (variantId === SHOTGLASS_VARIANT_ID || variantId === SHOTGLASS_VARIANT_ID_OLD) {
          productIdToRemove = SHOTGLASS_PRODUCT_ID;
        } else {
          productIdToRemove = SCOOP_PRODUCT_ID;
        }
          
        const domItem = document.querySelector(`[data-product-id="${productIdToRemove}"]`);
        
        if (domItem) {
          domItem.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
          domItem.style.opacity = '0';
          domItem.style.transform = 'translateX(-20px)';
          
          setTimeout(() => {
            domItem.remove();
            console.log(`  🗑️ Removed ${itemName} from DOM`);
          }, 300);
        }

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:updated', { bubbles: true })
        );

        setTimeout(async () => {
          try {
            const updatedCart = await getCart();
            if (updatedCart) {
              const cartCountElements = document.querySelectorAll(
                'm-cart-count, [data-cart-count], .cart-count'
              );
              cartCountElements.forEach(el => {
                el.textContent = updatedCart.item_count;
              });
            }
          } catch (e) {
            console.log('Could not update cart count');
          }
        }, 100);

        isRemoving = false;
        return true;

      } else {
        console.error(`  ❌ Failed to remove ${itemName}`, response.status);
        isRemoving = false;
        return false;
      }
    } catch (error) {
      console.error(`Error removing ${itemName}:`, error);
      isRemoving = false;
      return false;
    }
  }

  async function checkCartState() {
    const cart = await getCart();
    if (!cart) return { hasSubscription: false, hasBiMonthly: false, hasProducts: false };

    let hasSubscription = false;
    let hasBiMonthly = false;
    let hasProducts = false;

    console.log('🔎 Checking cart items:', cart.items.map(i => ({
      id: i.variant_id,
      title: i.title,
      hasSellingPlan: !!i.selling_plan_allocation,
      sellingPlanId: i.selling_plan_allocation?.selling_plan?.id
    })));

    cart.items.forEach(item => {
      const variantId = String(item.variant_id);
      
      // Skip gifts
      if (variantId === SHOTGLASS_VARIANT_ID || 
          variantId === SHOTGLASS_VARIANT_ID_OLD || 
          variantId === SCOOP_VARIANT_ID) {
        console.log('  ⏭️ Skipping gift:', item.title);
        return;
      }

      hasProducts = true;
      console.log('  ✅ Found product:', item.title);

      const hasSellingPlan = item.selling_plan_allocation !== null && 
                             item.selling_plan_allocation !== undefined;
      
      if (hasSellingPlan) {
        hasSubscription = true;
        console.log('  📦 Has subscription');
        
        // Check if this specific item in cart has a bi-monthly plan
        const sellingPlanId = item.selling_plan_allocation?.selling_plan?.id;
        const sellingPlanName = item.selling_plan_allocation?.selling_plan?.name || '';
        
        console.log('    → Selling Plan ID:', sellingPlanId);
        console.log('    → Selling Plan Name:', sellingPlanName);
        
        // Known bi-monthly plan IDs
        const biMonthlyPlanIds = [
          690455347542,  // Regular bi-monthly
          690482381142,  // Bundle bi-monthly
          '690455347542',
          '690482381142'
        ];
        
        // Check by plan ID (most reliable)
        const isBiMonthlyById = biMonthlyPlanIds.includes(sellingPlanId) || 
                                biMonthlyPlanIds.includes(String(sellingPlanId));
        
        // Check by plan name (fallback)
        const isBiMonthlyByName = sellingPlanName.toLowerCase().includes('2 maand') ||
                                  sellingPlanName.toLowerCase().includes('bi-month') ||
                                  sellingPlanName.toLowerCase().includes('2 months');
        
        if (isBiMonthlyById || isBiMonthlyByName) {
          hasBiMonthly = true;
          console.log('  🔄 Is bi-monthly (verified by selling plan)');
        } else {
          console.log('  📅 Is monthly (not bi-monthly)');
        }
      }
    });

    console.log('📦 Cart state:', { hasSubscription, hasBiMonthly, hasProducts });
    return { hasSubscription, hasBiMonthly, hasProducts };
  }

  // ============================================================
  // SIMPLIFIED MONITORING LOGIC
  // ============================================================

  async function monitorCart() {
    const cart = await getCart();
    if (!cart) return;

    const { hasSubscription, hasBiMonthly, hasProducts } = await checkCartState();

    const hasShotglass = cart.items.some(item => 
      String(item.variant_id) === SHOTGLASS_VARIANT_ID ||
      String(item.variant_id) === SHOTGLASS_VARIANT_ID_OLD
    );

    const hasScoop = cart.items.some(item => 
      String(item.variant_id) === SCOOP_VARIANT_ID
    );

    console.log('🔍 Monitor check:', { 
      hasShotglass, 
      hasScoop, 
      hasProducts,
      hasBiMonthly,
      userIsDeleting,
      isInitialized
    });

    let didRemoveSomething = false;

    // RULE 1: Remove shotglass if NO products
    if (hasShotglass && !hasProducts) {
      console.log('⚠️ Shotglass found but no products - removing');
      didRemoveSomething = true;
      
      await removeItemFromCart(SHOTGLASS_VARIANT_ID, 'shotglass');
      
      const hasOldVariant = cart.items.some(item => 
        String(item.variant_id) === SHOTGLASS_VARIANT_ID_OLD
      );
      if (hasOldVariant) {
        await removeItemFromCart(SHOTGLASS_VARIANT_ID_OLD, 'shotglass (old)');
      }
      
      setTimeout(async () => {
        const updatedCart = await getCart();
        if (updatedCart && updatedCart.item_count === 0 && window.location.pathname === '/cart') {
          sessionStorage.setItem('bioshots_cart_notification', JSON.stringify({
            message: 'Het gratis shotglaasje is verwijderd omdat je winkelwagen leeg is.',
            type: 'info'
          }));
          window.location.reload();
        } else if (isInitialized && didRemoveSomething) {
          showNotification(
            'Het gratis shotglaasje is verwijderd omdat je winkelwagen leeg is.',
            'info'
          );
        }
      }, 800);
    }

    // RULE 2: Remove scoop if NO bi-monthly subscription
    if (hasScoop && !hasBiMonthly) {
      console.log('⚠️ Scoop found but no bi-monthly subscription - removing');
      didRemoveSomething = true;
      
      await removeItemFromCart(SCOOP_VARIANT_ID, 'scoop');
      
      setTimeout(async () => {
        const updatedCart = await getCart();
        const willRefresh = updatedCart && updatedCart.item_count === 0 && window.location.pathname === '/cart';
        
        if (!willRefresh && isInitialized && didRemoveSomething) {
          showNotification(
            'Het gratis maatschepje is verwijderd omdat je geen 2-maands abonnement meer in je winkelwagen hebt.',
            'info'
          );
        } else if (willRefresh) {
          sessionStorage.setItem('bioshots_cart_notification', JSON.stringify({
            message: 'De gratis cadeaus zijn verwijderd omdat je winkelwagen leeg is.',
            type: 'info'
          }));
        }
      }, 500);
    }

    // Add badges and lock quantities for remaining gifts
    if (hasShotglass && hasProducts) {
      setTimeout(addGiftBadges, 300);
      setTimeout(lockGiftQuantities, 400);
    }
    if (hasScoop && hasBiMonthly) {
      setTimeout(addGiftBadges, 300);
      setTimeout(lockGiftQuantities, 400);
    }
  }

  // ============================================================
  // USER DELETION DETECTION
  // ============================================================

  function setupDeleteButtonListeners() {
    const deleteButtons = document.querySelectorAll('.m-cart-item__remove');

    deleteButtons.forEach(btn => {
      if (btn.hasAttribute('data-bioshots-listener')) return;
      
      btn.setAttribute('data-bioshots-listener', 'true');
      
      btn.addEventListener('click', function() {
        console.log('🖱️ User clicked delete button');
        userIsDeleting = true;
        
        setTimeout(() => {
          console.log('✅ First check after deletion');
          userIsDeleting = false;
          monitorCart();
        }, 1500);
        
        setTimeout(() => {
          console.log('✅ Second check after deletion');
          monitorCart();
        }, 3000);
        
        setTimeout(() => {
          console.log('✅ Final check after deletion');
          monitorCart();
        }, 4500);
      });
    });
  }

  // ============================================================
  // EVENT LISTENERS
  // ============================================================

  const cartUpdateEvents = [
    'cart:updated',
    'cart.updated', 
    'cart:refresh',
    'cartUpdated'
  ];

  cartUpdateEvents.forEach(eventName => {
    document.addEventListener(eventName, function() {
      console.log('🔔 Cart update detected via:', eventName);
      setTimeout(() => {
        setupDeleteButtonListeners();
        monitorCart();
      }, 500);
      setTimeout(addGiftBadges, 300);
      setTimeout(lockGiftQuantities, 400);
    });
  });

  if (window.location.pathname === '/cart') {
    const observer = new MutationObserver(function(mutations) {
      const cartChanged = mutations.some(mutation => {
        return Array.from(mutation.removedNodes).some(node => {
          return node.nodeType === 1 && node.classList && node.classList.contains('m-cart-item');
        });
      });

      if (cartChanged) {
        console.log('🔔 Cart item removed detected');
        setTimeout(monitorCart, 500);
        setTimeout(monitorCart, 2000);
        setTimeout(monitorCart, 3500);
      }
      
      const hasNewButtons = mutations.some(mutation => {
        return Array.from(mutation.addedNodes).some(node => {
          return node.nodeType === 1;
        });
      });
      
      if (hasNewButtons) {
        setupDeleteButtonListeners();
        setTimeout(lockGiftQuantities, 300);
      }
    });

    const cartContainer = document.querySelector('#MinimogCartBody');
    
    if (cartContainer) {
      observer.observe(cartContainer, {
        childList: true,
        subtree: true
      });
      console.log('👀 Observing cart for changes');
    }
  }

  let lastCartCount = 0;
  let monitorTimeout = null;
  
  async function pollCart() {
    const cart = await getCart();
    if (!cart) return;

    if (cart.item_count !== lastCartCount) {
      console.log('🔔 Cart count changed:', lastCartCount, '→', cart.item_count);
      lastCartCount = cart.item_count;
      
      if (monitorTimeout) clearTimeout(monitorTimeout);
      
      await monitorCart();
      monitorTimeout = setTimeout(monitorCart, 2000);
      monitorTimeout = setTimeout(monitorCart, 4000);
    }
  }

  if (window.location.pathname === '/cart') {
    setInterval(pollCart, 2000);
    pollCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(() => {
        waitForBiMonthlyVariants(function() {
          console.log('🚀 Variants loaded, running monitor...');
          setupDeleteButtonListeners();
          monitorCart();
          isInitialized = true;
          checkForSavedNotification();
        });
      }, 500);
      
      if (window.location.pathname === '/cart') {
        setTimeout(addGiftBadges, 1500);
        setTimeout(lockGiftQuantities, 1600);
      }
    });
  } else {
    setTimeout(() => {
      waitForBiMonthlyVariants(function() {
        console.log('🚀 Variants loaded, running monitor...');
        setupDeleteButtonListeners();
        monitorCart();
        isInitialized = true;
        checkForSavedNotification();
      });
    }, 500);
    
    if (window.location.pathname === '/cart') {
      setTimeout(addGiftBadges, 1500);
      setTimeout(lockGiftQuantities, 1600);
    }
  }

  function checkForSavedNotification() {
    try {
      const saved = sessionStorage.getItem('bioshots_cart_notification');
      if (saved) {
        const notification = JSON.parse(saved);
        console.log('📬 Showing saved notification after refresh');
        setTimeout(() => {
          showNotification(notification.message, notification.type);
        }, 1000);
        sessionStorage.removeItem('bioshots_cart_notification');
      }
    } catch (e) {
      console.log('No saved notification');
    }
  }

  function saveBiMonthlyVariants() {
    if (window.biMonthlyVariants && window.biMonthlyVariants.length > 0) {
      try {
        let existingVariants = [];
        const saved = sessionStorage.getItem('bioshots_bimonthly_variants');
        if (saved) {
          existingVariants = JSON.parse(saved);
        }
        
        window.biMonthlyVariants.forEach(variantId => {
          if (existingVariants.indexOf(variantId) === -1) {
            existingVariants.push(variantId);
          }
        });
        
        sessionStorage.setItem('bioshots_bimonthly_variants', JSON.stringify(existingVariants));
        window.biMonthlyVariants = existingVariants;
        
        console.log('💾 Saved bi-monthly variants to session:', existingVariants);
      } catch (e) {
        console.warn('Could not save to sessionStorage:', e);
      }
    }
  }

  let variantCheckCount = 0;
  const maxVariantChecks = 10;
  
  function waitForBiMonthlyVariants(callback) {
    variantCheckCount++;
    
    if (window.biMonthlyVariants && window.biMonthlyVariants.length > 0) {
      console.log('✅ Bi-monthly variants registered:', window.biMonthlyVariants);
      saveBiMonthlyVariants();
      if (callback) callback();
      return;
    }
    
    const saved = getBiMonthlyVariants();
    if (saved.length > 0) {
      console.log('✅ Loaded bi-monthly variants from session');
      if (callback) callback();
      return;
    }
    
    if (variantCheckCount < maxVariantChecks) {
      console.log(`⏳ Waiting for bi-monthly variants... (${variantCheckCount}/${maxVariantChecks})`);
      setTimeout(() => waitForBiMonthlyVariants(callback), 200);
    } else {
      console.log('⚠️ Bi-monthly variants not found after waiting, proceeding anyway');
      if (callback) callback();
    }
  }

  setInterval(saveBiMonthlyVariants, 5000);

  console.log('✅ Cart monitor v9 ready (Simplified - no bundle checks!)');
})();